/**
 * The home hero's background, per theme (owner, 2026-10-16: every theme gets its own motif, not just
 * its colours). A theme listed here draws its own board behind the hero and as the page's wallpaper;
 * every other theme, and the site with no theme picked, keeps the circuit board. Motifs are added one
 * theme at a time, each designed with the owner.
 */
export type HeroMotif = 'circuit' | 'aurora' | 'sakura' | 'autumn' | 'everest' | 'sequoia' | 'roraima' | 'salda' | 'ocean' | 'spring' | 'reynisfjara' | 'fuji' | 'etna' | 'istanbul' | 'miami' | 'rio' | 'paris' | 'tallinn' | 'tokyo' | 'sydney' | 'prague' | 'madrid' | 'vienna' | 'dublin' | 'london' | 'bioluminescence';

export const HERO_MOTIFS: Record<string, HeroMotif> = {
  'aurora-borealis': 'aurora',
  'sakura': 'sakura',
  'autumn': 'autumn',
  'everest': 'everest',
  'sequoia': 'sequoia',
  'roraima': 'roraima',
  'salda': 'salda',
  'ocean': 'ocean',
  'spring': 'spring',
  'reynisfjara': 'reynisfjara',
  'fuji': 'fuji',
  'etna': 'etna',
  'istanbul': 'istanbul',
  'miami': 'miami',
  'rio-de-janeiro': 'rio',
  'paris': 'paris',
  'tallinn': 'tallinn',
  'tokyo': 'tokyo',
  'sydney': 'sydney',
  'prague': 'prague',
  'madrid': 'madrid',
  'vienna': 'vienna',
  'dublin': 'dublin',
  'london': 'london',
  'bioluminescence': 'bioluminescence',
};

export function heroMotifFor( themeKey: string | undefined | null ): HeroMotif {
  return ( themeKey && HERO_MOTIFS[ themeKey ] ) || 'circuit';
}

/** What the home asks of whichever board is drawn: a charge while the counter counts, a short wake. */
export interface HeroBoard {
  charge( on: boolean ): void;

  pulse( seconds?: number ): void;
}
